import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { setActiveCommunity } from '../../../actions/userActions'
import CommunityAvatarPlaceholder from '../../../assets/images/mock/classRowBanner.png'

import classes from './CommunityChooser.module.scss'

const CommunityChooser = ({ user }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const chooseCommunity = (community) => dispatch(setActiveCommunity(community.id))

  return (
    <div className={classNames(classes.communityChooser, 'd-flex align-items-center justify-content-center')}>
      <div className={classNames(classes.card, 'w-100 bg-white text-center')}>
        {user.avatar?.file_url && (
          <img
            className={classNames(classes.userAvatar, 'rounded-circle mb-3')}
            src={user.avatar.file_url}
            alt={`${user.first_name} ${user.last_name}`}
          />
        )}
        <p className={classNames(classes.loggedInAs, 'mb-1')}>
          {t('common.communityChooser.loggedInAs', { name: `${user.first_name} ${user.last_name}` })}
        </p>
        <h2 className='font-weight-bold mb-2'>{t('common.communityChooser.title')}</h2>
        <p className={classNames(classes.subtitle, 'mb-4')}>{t('common.communityChooser.subtitle')}</p>
        <ul className={classNames(classes.communityList, 'list-unstyled overflow-auto mb-0')}>
          {user.communities.map((community) => (
            <li key={community.id}>
              <button
                type='button'
                className={classNames(classes.communityEntry, 'd-flex align-items-center w-100 bg-white text-left')}
                onClick={() => chooseCommunity(community)}
              >
                <div className={classNames(classes.communityLogo, 'medium-round-image-wrapper')}>
                  <img className='round-image' src={community.photo ? community.photo.file_url : CommunityAvatarPlaceholder} alt={community.name} />
                </div>
                <span className='ml-3 d-flex flex-column'>
                  <span className={classes.communityName}>{community.name}</span>
                  <span className={classes.communityEnrollments}>
                    {t('common.activeEnrollments', { count: community.active_enrollments_count || 0 })}
                  </span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

CommunityChooser.propTypes = {
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    avatar: PropTypes.shape({ file_url: PropTypes.string }),
    communities: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      active_enrollments_count: PropTypes.number,
      photo: PropTypes.shape({ file_url: PropTypes.string }),
    })),
  }).isRequired,
}

export default CommunityChooser
